import $ from 'jquery'

//Add space every 3 number
$('.vehicle-price-block__result-value').each(function() {
    var text = $(this).text();
    text = text.split('').reverse().join('');
    text = text.replace(/\d{3}(?!$)/g, '$& ');
    text = text.split('').reverse().join('');
    $(this).text(text);
});
